/*
 * @Author: 赵健
 * @Date: 2021-01-25 17:43:59
 * @LastEditTime: 2021-01-27 10:49:55
 * @LastEditors: 赵健
 * @Description: 修改描述
 * @FilePath: \trunk\src\api\dashBoard.js
 */
import request from '@/utils/request'

// 【商家端 - 登录接口】 商家端首页记录数接口
export function merchantRecordNum(data) {
  return request({
    url: '/api/merchant/recordNum',
    method: 'post',
    data
  })
}
